import { Directive, HostListener, Input } from "@angular/core";
import { AnalyticsButtonEventParams, AnalyticsService } from "../services/analytics.service";

@Directive({
  selector: "[eventTracker]",
})
export class ButtonAnalyticsEventTrackerDirective {
  @Input("eventTracker") option: AnalyticsButtonEventParams;

  @HostListener("click", ["$event"]) onClick($event: Event) {
    this.analytics.trackEvent(
      this.option.event,
      this.option.category,
      this.option.action,
      this.option.label,
      this.option.value
    );
  }

  constructor(private analytics: AnalyticsService) {}
}
